import React, { useState, Fragment, useEffect } from "react";
import moment from "moment";
import ButtonSwitcher from "../../../components/ButtonSwitcher";

import EventInfo from "./EventInfo";
import EventMedia from "./EventMedia";
import ContentTags from "./ContentTags";

import { ContentTypes } from "../../../Constants/selections";

import "./AddEvent.css";

const tabs = ["Event info", "Event media", "Content tags"];
const types = [
  { label: "Physical", value: "physical" },
  { label: "Streaming", value: "streaming" },
];
const redemptionTypes = [
  { label: "RSVP", value: "rsvp" },
  { label: "Ticketed", value: "ticket" },
];
const initEvent = {
  title: "",
  // postcode: "",
  // building: "",
  description: "",
  address: { formatted_address: "", building: "", postcode: "" },
  token: 0,
  price: null,
  selectedDay: 0,
  type: "physical",
  redemptionType: "rsvp",
  isrecurring: true,
  selectedDate: null,
  start_time: { hh: "00", mm: "00", of: "am", utc: 0 },
  end_time: { hh: "00", mm: "00", of: "am", utc: 0 },
  purchaseType: "quickbuy",
  mediaUrl: "",
  contentType: "",
  article: {},
};

const EditEvent = ({
  updateEvent,
  articles,
  hotTopicTags,
  products,
  currentEvent,
  deleteEvent,
  deleteEventBtnRef,
  hex,
  white,
}) => {
  const [tab, setTab] = useState(tabs[0]);
  const [event, setEvent] = useState(initEvent);

  useEffect(() => {
    if (JSON.stringify(currentEvent) !== "{}") {
      setEvent(currentEvent);
    } else {
      setEvent(initEvent);
    }
  }, [currentEvent]);

  const handleChangeTab = (tab) => {
    setTab(tab);
  };

  const handleClickSave = () => {
    const {
      title,
      token,
      postcode,
      address,
      isrecurring,
      day,
      selectedDay,
      start_time,
      end_time,
      type,
      date,
      building,
      description,
      selectedDate,
      media_type,
      media_url,
      purchaseType,
      redemptionType,
      price,
      article,
      hotTopicTag,
      productTag,
    } = event;
    let time = null;
    let payload = {
      title,
      type,
      address,
      start_time,
      end_time,
      isrecurring,
      description,
      selectedDate,
      token: Number(token),
      media_type,
      media_url,
      purchaseType,
      redemptionType,
      price,
      article: article || null,
      hotTopicTag: hotTopicTag || null,
      productTag: productTag || null,
    };
    if (!isrecurring) {
      const { hh, mm, of, utc } = start_time;
      let hours = Number(hh);
      let minutes = Number(mm);
      if (of === "pm" && hours < 12) hours = hours + 12;
      if (of === "am" && hours === 12) hours = hours - 12;
      let m = moment();
      m.utcOffset(utc);
      const new_date = new Date(
        `${date}T${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:00`
      );
      const newDate = moment(new_date);
      m.set(newDate.toObject());
      time = m.valueOf(); //m.toDate();
      payload.time = time;
      payload.date = date;
      // console.log("time", moment(time).toDate());
      // console.log("date", date);
    } else {
      payload.day = day;
    }
    updateEvent(event.id, payload);
  };

  const onChangeEventInfo = (eventInfo) => {
    const newEvent = { ...event, ...eventInfo };
    // console.log("eventInfo", eventInfo);
    if (JSON.stringify(newEvent) !== JSON.stringify(event)) {
      setEvent(newEvent);
    }
  };

  const onChangeMedia = (media) => {
    const newEvent = {
      ...event,
      media_type: media.contentType.value,
      media_url: media.mediaUrl,
    };
    if (JSON.stringify(newEvent) !== JSON.stringify(event)) {
      setEvent(newEvent);
    }
  };

  const onChangeTags = (tags) => {
    const newEvent = { ...event, ...tags };
    if (JSON.stringify(newEvent) !== JSON.stringify(event)) {
      setEvent(newEvent);
    }
  };

  const checkValidation = () => {
    const {
      title,
      token,
      address,
      date,
      isrecurring,
      building,
      description,
      selectedDate,
      type,
    } = event;
    const date_validation = isrecurring ? true : date;
    const title_validation = title ? true : false;
    const address_validation =
      type === "physical" ? (address ? true : false) : true;
    const token_validation = token ? true : false;
    const building_validation =
      type === "physical" ? (address.building ? true : false) : true;
    const description_validation = description ? true : false;
    const validation =
      title_validation &&
      address_validation &&
      token_validation &&
      building_validation &&
      description_validation &&
      (date_validation || selectedDate);
    return validation;
  };

  return (
    <div
      className="modal fade add-event-dialog"
      id="edit_event_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content add-event-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit an event</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              style={{ marginLeft: "10px" }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1 add-event-dialog-body">
            <div className="swtich-bar-container">
              <ButtonSwitcher
                buttonsGroup={tabs}
                currentTab={tab}
                onSwitch={handleChangeTab}
                hex={hex}
                white={white}
              />
            </div>
            <EventInfo
              onChangeEventInfo={onChangeEventInfo}
              isEdit={true}
              currentInfo={{
                title: event.title,
                // postcode: event.address && event.address.postcode,
                // building: event.address && event.address.building,
                description: event.description,
                address: event.address,
                token: event.token,
                price: event.price,
                date: event.date,
                day: event.day,
                type: event.type, //types.find((t) => t.value === event.type) || types[0],
                redemptionType: event.redemptionType,
                isrecurring: event.isrecurring,
                selectedDate: event.selectedDate,
                start_time: event.start_time,
                end_time: event.end_time,
                purchaseType: event.purchaseType,
              }}
              isVisible={tab === "Event info" ? true : false}
            />
            <EventMedia
              onChangeMedia={onChangeMedia}
              currentMedia={{
                mediaUrl: event.media_url,
                contentType:
                  ContentTypes.find((t) => t.value === event.media_type) ||
                  null,
              }}
              isVisible={tab === "Event media" ? true : false}
            />
            <ContentTags
              onChangeTags={onChangeTags}
              articles={articles}
              hotTopicTags={hotTopicTags}
              products={products}
              currentTags={{
                article:
                  articles.find((article) => article.id === event.article) ||
                  null,
                hotTopicTag:
                  hotTopicTags.find(
                    (hotTopic) => hotTopic.id === event.hotTopicTag
                  ) || null,
                productTag:
                  products.find((product) => product.id === event.productTag) ||
                  null,
              }}
              isVisible={tab === "Content tags" ? true : false}
            />
          </div>
          <div className="modal-footer footer-container">
            <div className="btn-action-container">
              {tab === "Event info" && (
                <React.Fragment>
                  <button
                    className="btn btn-delete"
                    data-dismiss="modal"
                    style={{ marginRight: "auto" }}
                    onClick={() => deleteEventBtnRef.current.click()}
                  >
                    Delete X
                  </button>
                  <button
                    type="button"
                    className="btn btn-brand-hex btn-white"
                    style={{
                      "--hover-color": "white",
                      "--hover-text-color": "black",
                      backgroundColor: hex ? hex : "white",
                      color: white ? "white" : "black",
                    }}
                    onClick={() => setTab("Event media")}
                  >
                    Next
                  </button>
                </React.Fragment>
              )}
              {tab === "Event media" && (
                <Fragment>
                  <button
                    type="button"
                    className="btn btn-white"
                    onClick={() => setTab("Event info")}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn btn-brand-hex btn-white"
                    style={{
                      "--hover-color": "white",
                      "--hover-text-color": "black",
                      backgroundColor: hex ? hex : "white",
                      color: white ? "white" : "black",
                    }}
                    onClick={() => setTab("Content tags")}
                  >
                    Next
                  </button>
                </Fragment>
              )}
              {tab === "Content tags" && (
                <Fragment>
                  <button
                    type="button"
                    className="btn btn-white"
                    onClick={() => setTab("Event media")}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn btn-green"
                    data-dismiss="modal"
                    disabled={!checkValidation()}
                    onClick={handleClickSave}
                  >
                    Save
                  </button>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditEvent;



// WEBPACK FOOTER //
// ./src/screens/Event/components/EditEvent.js